import { btApi } from '../../btsms/services/btApi';
import { messengerApi } from '../../messenger/services/messengerApi';
import { twitterApi } from '../../twitter/services/twitterApi';
import { govNotifyApi } from '../../govuknotifysms/services/govNotifyApi';
import { instagramApi } from '../../messenger/services/instagramApi';
import { googleBmApi } from '../../googlebm/services/googlebmApi';

export interface IAppApiUninstall {
	uninstall(workspaceId: string, installId: string): Promise<void>;
	canUninstall(): boolean;
	getUninstallNotAllowedMessage(): string;
}
const apis: {[key: string]: IAppApiUninstall} = {
	'btsms': btApi,
	'messenger': messengerApi,
	'twitter': twitterApi,
	'govuknotifysms': govNotifyApi,
	'instagram': instagramApi,
	'google-bm': googleBmApi
};

export const AppApiFactory = {
	get: (name: string) => apis[name]
};
